import type { AriaRole, ReactNode } from "react";

const TONE_CLASSES = {
  warning: "border-amber-300 bg-amber-100 text-amber-700",
  requiredAction: "border-red-300 bg-red-100 text-red-600",
} as const;

interface CreatorTopBannerProps {
  children: ReactNode;
  tone: keyof typeof TONE_CLASSES;
  role?: AriaRole;
  testId?: string;
}

export function CreatorTopBanner({
  children,
  tone,
  role = "status",
  testId,
}: CreatorTopBannerProps) {
  return (
    <div
      className={`relative z-50 w-full border-b px-4 py-2.5 text-center text-sm font-medium ${TONE_CLASSES[tone]}`}
      data-testid={testId}
      role={role}
    >
      {children}
    </div>
  );
}
